import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Clock } from 'lucide-react';
import { blogPosts } from '../../data/blogPosts';

export function LatestArticles({ currentSlug, maxPosts = 3 }) {
  const navigate = useNavigate();
  
  // Get latest posts excluding current page
  const latestPosts = blogPosts
    .filter(post => post.slug !== currentSlug)
    .slice(0, maxPosts);

  if (latestPosts.length === 0) return null;

  return (
    <Card className="p-6 bg-[var(--surface)] border border-[var(--border-custom)] rounded-xl">
      <h3 className="font-bebas text-2xl mb-4">Latest Nightlife Guides</h3>
      <div className="space-y-4">
        {latestPosts.map((post) => (
          <div
            key={post.id}
            onClick={() => navigate(`/blog/${post.slug}`)}
            className="cursor-pointer group"
          >
            <h4 className="font-semibold text-sm mb-1 group-hover:text-[var(--accent-gold)] transition-colors line-clamp-2">
              {post.title}
            </h4>
            <div className="flex items-center gap-2 text-xs text-[var(--text-muted)]">
              <Badge className="text-xs">{post.category}</Badge>
              <div className="flex items-center gap-1">
                <Clock size={12} />
                <span>{post.readTime}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <button
        onClick={() => navigate('/blog')}
        className="mt-4 text-sm text-[var(--accent-gold)] hover:underline"
      >
        View All Articles →
      </button>
    </Card>
  );
}
